<template>
  <div>
    <b-button>
        <i class="fas fa-edit" style="color:#0090CD" @click="openEditZone"></i>
    </b-button>

    <!-- Crea nuova zona Modal-->
    <b-modal
      ref="modal"
      size="lg"
      :id="'modal-edit-zone'+this._uid"
      :saveSubmit="saveSubmit"
      :title="$t('zone.edit_modal_title')"
      :ok-title="$t('user_modal.button_save')"
      :cancel-title="$t('user_modal.button_cancel')"
      @ok="handleOk"
    >
      <b-row>
      <b-col cols="9">
        
        <!--input name of zone -->
        <b-form-group class="ml-2">
          <label class="typo-label">{{$t("zone.label_zone_name")}}</label>
          <b-form-input
            v-model="zoneName"
            type="text"
            :state="validation_zoneName"
          ></b-form-input>
          <b-form-invalid-feedback
            :state="validation_zoneName"
          >{{$t("signup.validation_null")}}</b-form-invalid-feedback>
         </b-form-group>

          <!-- label collection selection-->
          <b-row class="px-3 py-2 mt-2">
           <b-col cols="12">
                <label class="typo-label">{{$t("zone.label_select_c")}}</label>
            </b-col>
          </b-row>

          <div v-for="(itemC,posC) in this.itemsCollection" :key="'coll_'+posC" class="px-3 mb-3">
              <b-row>
                <!-- select collection -->
                <b-col cols="4">
                    <b-form-select v-model="itemC.collection" :options="c_options" @change="onChangeCollection($event+'_'+posC)"  :state="validation_collection">
                      <template #first>
                        <b-form-select-option value="" >Seleziona</b-form-select-option>
                      </template>
                    </b-form-select>
                    <b-form-invalid-feedback :state="validation_collection">{{$t("signup.validation_null")}}</b-form-invalid-feedback>
                </b-col>

                <!-- plus button -->
                <b-col cols="1">   
                  <b-button style="color: #0090CD" @click="addInputCollection()"><i class="fas fa fa-1x fa-plus no-border"></i></b-button>
                </b-col>        
      
                <!-- remove button -->
                <b-col cols="1">   
                    <b-button v-if="posC>0" @click="function(){itemsCollection.splice(posC,1)}"><i class="fa fa-times pt-1"></i></b-button>
                </b-col>  
    
              </b-row>     
          </div> 

          <!-- label scenari selection-->
          <b-row class="px-3 py-2 mt-2">
           <b-col cols="12">
                <label class="typo-label">{{$t("zone.label_select_s")}}</label>
            </b-col>
          </b-row>

          <div v-for="(itemS,posS) in this.itemsScenari" :key="'scene_'+posS" class="px-3 mb-3">
              <b-row>
                <!-- select scenari -->
                <b-col cols="4">
                    <b-form-select v-model="itemS.sceneId" :options="s_options" @change="onChangeScenario($event+'_'+posS)"  :state="validation_scenari">
                    <template #first>
                      <b-form-select-option value="" >Seleziona</b-form-select-option>
                    </template>
                      
                    </b-form-select>
                    <b-form-invalid-feedback :state="validation_scenari">{{$t("signup.validation_null")}}</b-form-invalid-feedback>
                </b-col>

                <!-- plus button -->
                <b-col cols="1">   
                  <b-button style="color: #0090CD" @click="addInputScenari()"><i class="fas fa fa-1x fa-plus no-border"></i></b-button>
                </b-col>        
      
                <!-- remove button -->
                <b-col cols="1">   
                    <b-button v-if="posS>0" @click="function(){itemsScenari.splice(posS,1)}"><i class="fa fa-times pt-1"></i></b-button>
                </b-col>  
    
              </b-row>     
          </div> 

        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import GroupsCentralUnit from '@/components/GroupsCentralUnit'


export default {
  name: "EditZone",
  components:{
    GroupsCentralUnit
  },
  data() {
    return {
     zoneName: "",
     saveSubmit: "false",
     itemsCollection:[
        {
          collection: '',
        }
      ],
     itemsScenari:[
        {
          sceneId: '',
        }
      ],
     plantId:"",
     c_options:[],
     s_options:[]
    };
  },
   props: {
    zone:null,
  },
  computed: {
    validation_zoneName() {
      if (this.saveSubmit == true) return this.zoneName.length > 0;
    },
    validation_collection() {
      if (this.saveSubmit == true) return this.itemsCollection[0].collection != "" || this.itemsScenari[0].sceneId != "" ;
    },
    validation_scenari() {
      if (this.saveSubmit == true) return  this.itemsScenari[0].sceneId != "" || this.itemsCollection[0].collection != "";
    },
    collectionIdList(){
      console.log("Collections: ", this.$store.state.plantCollections);
      var collectionList=[];
      if(this.$store.state.plantCollections != null){
        for(var i=0;i<this.$store.state.plantCollections.length;i++)
        {
          collectionList.push({value: this.$store.state.plantCollections[i].collectionId, text: this.$store.state.plantCollections[i].collectionName});
        }
      }
      return collectionList;
    },
    /*scenariIdList(){
      console.log("scenari: ", this.$store.state.plantScenes);
      if (this.$store.state.plantScenes == null) return [];
      //var scenariList=[];
      return this.$store.state.plantScenes.map((s) => { return {value: s.sceneId, text: s.sceneName} })
      //return scenariList;
    }*/
  },
  /*mounted() {
        //console.log("mounted",this.plantDetails);
        //if (this.collectionIdList==null) 
        //    this.$store.dispatch('loadPlantCollections', this.plantId);               
  },*/
  methods: {
    openEditZone(bvModalEvt) {
      console.log("Edit zone: ",this.zone);
      this.saveSubmit = false;

      this.c_options=this.collectionIdList;
      this.s_options=this.$store.state.plantScenes.map((s) => { return {value: s.sceneId, text: s.sceneName} });
      
      console.log("s_options:",this.s_options);

      if(this.zone.collections == null || this.zone.collections.length == 0){
        this.itemsCollection=[
            {
                collection: ''
            }
        ];
      }else{
        
        this.itemsCollection = this.zone.collections.map(c => { return {collection: c} } );
        /*for(var i=0;i<this.itemsCollection.length;i++)
        {
          this.onChangeCent(this.itemsCollection[i].collection);
        }*/
      }
      console.log("itemsCollections=",this.itemsCollection);

      if(this.zone.scenes == null || this.zone.scenes.length == 0){
        this.itemsScenari=[
            {
                sceneId: ''
            }
        ];
      }else{
        this.itemsScenari = this.zone.scenes.map((s) => {return {sceneId: s}; });
        /*for(var i=0;i<this.itemsScenari.length;i++)
        {
          this.onChangeCent(this.itemsScenari[i].scenariName);
        }*/
      }

      this.zoneName = this.zone.zoneName;
      console.log("show edit modal " + this._uid);
      this.$bvModal.show('modal-edit-zone'+this._uid);
      
    },
    onChangeCollection(col_selected) {
      console.log("Collection selected: ", col_selected);
    },
    onChangeScenario(scen_selected) {
      console.log("Scenario selected: ", scen_selected);
    },
    clearInput()
    {
        this.saveSubmit = false;
        this.itemsCollection=[
            {
                collection: ''
            }
        ];
        this.itemsScenari=[
            {
                sceneId: ''
            }
        ];
    }, 
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      this.saveSubmit = true;
      // Trigger submit handler
      console.log("itemsScenari=",this.itemsScenari);

      this.updateZone();
    },
    addInputCollection()
    {
        var newItem={ collection: ''};
        this.itemsCollection.push(newItem);   
    },
    addInputScenari()
    {
        var newItem={ sceneId: ''};
        this.itemsScenari.push(newItem);   
    },
    updateZone() {     
      if (!this.validation_zoneName || !this.validation_collection || !this.validation_scenari) return; 
      
      let self = this;
      this.$nextTick(() => {
        console.log("hide edit modal " + self._uid);
        self.$bvModal.hide('modal-edit-zone'+self._uid);

        self.$store.dispatch("dbUpdateZone", {
            zoneId: self.zone.zoneId,
            plantId: self.$store.state.currentPlant.id,
            zoneName: this.zoneName,
            collections: (this.itemsCollection[0].collection == '') ? [] : this.itemsCollection.map(c => c.collection ),
            scenes: (this.itemsScenari[0].sceneId == '') ? [] : this.itemsScenari.map(s => s.sceneId)
          });

      });

      
    }
  }
};
</script>
